import React, { PureComponent, ReactNode } from "react";
import "./OptionMenuToggle.css";

interface Props<T> {
  title: string;
  optionShortNames: Array<T>;
  optionDescriptions: Array<string>;
  extraInfo?: ReactNode;
  selected: T;
  printShortName: (sn: T) => string;
  onChange: (value: T) => void;
}
interface State {}

class OptionMenuToggle<T> extends PureComponent<Props<T>, State> {
  constructor(props: Props<T>) {
    super(props);
    this.state = {};
  }

  curriedSelect = (opt: T) => () => {
    this.props.onChange(opt);
  };

  render(): ReactNode {
    const { title, optionShortNames, optionDescriptions, selected, printShortName, extraInfo } = this.props;
    const selectedIndex = optionShortNames.findIndex((o) => o === selected);
    return (
      <div className="open-menu-toggle-wrapper">
        <h4 className="option-menu-title">{title}</h4>
        <div className="option-menu-selections">
          {optionShortNames.map((osn, index) => {
            const shortName = printShortName(osn); // Maybe require string mapper func
            const selectedClass = index === selectedIndex ? "selected" : "";
            const className = `option-menu-toggle-shortname ${selectedClass}`;
            return (
              <span key={shortName} className={className}>
                <button onClick={this.curriedSelect(osn)}>{shortName}</button>
              </span>
            );
          })}
        </div>
        <div className="option-menu-description">{optionDescriptions[selectedIndex]}</div>

        {extraInfo && <div className="option-menu-extra-info">{extraInfo}</div>}
      </div>
    );
  }
}

export default OptionMenuToggle;
